var map = {
	"./arrow-down-cart.svg": 29380,
	"./arrow-down-trigger.svg": 86122,
	"./arrow-down.svg": 55485,
	"./arrow-left-new.svg": 65227,
	"./arrow-left-v2.svg": 71131,
	"./arrow-left-v3.svg": 2314,
	"./arrow-right-cart.svg": 57100,
	"./arrow-right-old.svg": 22089,
	"./arrow-right-order.svg": 58050,
	"./arrow-right-v2.svg": 48586,
	"./arrow-right-v3.svg": 1051,
	"./arrow-right.svg": 85605,
	"./arrow-up.svg": 67682,
	"./ask.svg": 98179,
	"./check-mark.svg": 29175,
	"./check.svg": 61115,
	"./closed.svg": 36161,
	"./delete.svg": 70668,
	"./delivery-shop.svg": 95942,
	"./done.svg": 84409,
	"./edit.svg": 47713,
	"./icon-address.svg": 19909,
	"./icon-ads-plus.svg": 28808,
	"./icon-arrow-down.svg": 34935,
	"./icon-cart.svg": 93657,
	"./icon-comment.svg": 83606,
	"./icon-del.svg": 9770,
	"./icon-discount.svg": 32054,
	"./icon-fav.svg": 26274,
	"./icon-like.svg": 38118,
	"./icon-local.svg": 10364,
	"./icon-location.svg": 98798,
	"./icon-lottery.svg": 91950,
	"./icon-menu-v2.svg": 71111,
	"./icon-menu-v3.svg": 7286,
	"./icon-menu.svg": 44090,
	"./icon-pk.svg": 57232,
	"./icon-return.svg": 2449,
	"./icon-share-v2.svg": 69157,
	"./icon-share.svg": 2988,
	"./icon-switch-light.svg": 54639,
	"./icon-switch.svg": 63503,
	"./icon-tab-home.svg": 89324,
	"./icon-tab-kefu.svg": 34506,
	"./icon-tab-shopcart.svg": 96503,
	"./icon-tui-kuan.svg": 27609,
	"./icon-x.svg": 55297,
	"./plus.svg": 56657,
	"./qa-ask.svg": 64439,
	"./qa-zan-active.svg": 83574,
	"./qa-zan.svg": 73431,
	"./search-gray.svg": 40487,
	"./search-v2.svg": 90546,
	"./search.svg": 22701,
	"./select-disable.svg": 87194,
	"./selected.svg": 83226,
	"./star.svg": 77841,
	"./triangle-down.svg": 29422,
	"./triangle-up.svg": 12754,
	"./unselected-v2.svg": 61140,
	"./unselected.svg": 74211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;